import { getReportExportTimerConfig } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetReportExportTimer = (enabled: boolean) => {
  const { data, status } = useQuery(
    ['reschedule-reasons'],
    () => getReportExportTimerConfig(),
    {
      enabled,
    }
  );

  return {
    data,
    status,
  };
};
